module.exports = __webpack_public_path__ + "media/de_de_s1_Adelie.fd944e6d.oga";